import API from "./api";
import * as Sentry from "@sentry/react";
import { storage } from "../services/config/storage";
import { GC } from "../services/config/gameCenteService";

// const gameId = '85eb2298-246e-4eca-b99c-6700135db1aa';

const logError = (error) => {
  console.error(
    `ERROR::${process.env.REACT_APP_GAME_NAME}::sendData::${error}`
  );

  if(error?.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      Sentry.setExtra("response", error.response)
      Sentry.captureException(error)
  } else if(error?.request) {
      // The request was made but no response was received
      Sentry.setExtra("request", error.request)
      Sentry.captureException(error)
  } else {
      // Something happened in setting up the request that triggered an Error
      Sentry.captureException(error?.message)
  }
}

export function sendResult(result) {
  GC.sendGameDataSaveMessage(result);
}

// export function sendResult(result) {

//   const gameId = storage.get.gameId();
//   const authToken = storage.get.authToken();
//   const gameplayId = storage.get.gameplayId();

//   console.log("========GET SESSION RESULT========");
//   console.log(authToken);
//   console.log(gameplayId);

//   API.post(`${process.env.REACT_APP_API_ENDPOINT}/api/session/v1/${gameId}/link/${gameplayId}`, {
//     ...result,
//   }, {
//     headers: {
//       Authorization: authToken,
//     },
//   }
//   )
//     .then((result) => {
//       console.log("SUCCESSFULLY UPDATED THE DATA IN THE BACKEND!");
//     })
//     .catch((error) => {
//       console.log(`ERROR::${process.env.REACT_APP_GAME_NAME}::sendResult::${error}`);
//       logError(error);
//     });
// }

const inverseTransform = ({ game }) => {
  return game.gameData.levelData.length;
};


export function syncGameData() {

  const gameId = storage.get.gameId();
  const authToken = storage.get.authToken();
  const gameplayId = storage.get.gameplayId();

  console.log("========GET SESSION RESULT========");
  console.log(authToken);
  console.log(gameplayId);

  API.get(`${process.env.REACT_APP_API_ENDPOINT}/api/game/v1/${gameId}/link/b9625004-4d99-485f-b445-f9d556d9c76e`, {
    headers: {
      Authorization: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJlNGUxMDFhNy1iZmQzLTRiMDQtYWYzYy1jMjNkMjBlZGU4OGEiLCJzZXNzaW9uSWQiOiIzMThkYjg2Zi1hYzMyLTQ1NGEtYWViZi04YTAxMTJlNGU0MzYiLCJpc0FkbWluIjpmYWxzZSwiaWF0IjoxNjIyOTg5MjQ3LCJleHAiOjE2MjU1ODEyNDcsImF1ZCI6ImdyYXBwdXMiLCJpc3MiOiJncmFwcHVzIiwic3ViIjoiQXV0aGVudGljYXRpb24gVG9rZW4ifQ.uzsPCKwA9zTflm7U3dyaw1uQRFmOgxVs3jhqj-wOIVeUQxxHJvYBPStDeJGHzRpCaS5B8R947Fh0BYo5r7Fjy6U8CmEFFYVSvcF5PzFRf74GFGIkOQuHF54Fgqu7Lwz2q9BDn4rxh1zaDK4_VyEBVpVEcJ8j2zkJVQORlFH0aJtyn-8bDJ2PT4vqoeRbeeDPiavb3_iaOPSCEJD5XoOFC0svKYbjDFjnwn540VNlL-hPZjScL6tnUAiDcHntzdQGEX8j1fkDyc9xbQBE2njkTOpMlOoniiTWxocg3JqVOFhb5YURC9bb-n6qlPTkHi9es_Usx2Gml7Obz7Vz636OJw",
    },
  }).then((result) => {
    console.log(result)
    if (result) {
      return inverseTransform(result)
    }
  })
    .catch((error) => {
      console.log(`ERROR::${process.env.REACT_APP_GAME_NAME}::syncGameData::${error}`);
      logError(error);
    });
}